import { create } from 'zustand';

import { getFlashback } from '@/service/flashback';
import type { IFlashback, IReqFlashback } from '@/service/flashback';

interface TypeFlashbackStore {
  flashback: IFlashback | undefined;
  fetchFlashback: () => void;
  setFlashback: (flashback: IFlashback, propertyToUpdate?: keyof IFlashback) => void;
}

const useFlashbackStore = create<TypeFlashbackStore>()((set, get) => ({
  flashback: undefined,
  fetchFlashback: (data?: IReqFlashback) => {
    getFlashback(data).then((res) => {
      if (res.data.code === 0 && res.data.data) {
        set({ flashback: { ...res.data.data, unread: true } });
      }
    });
  },
  setFlashback: (flashback, propertyToUpdate) => {
    if (!propertyToUpdate) {
      set({ flashback });

      return;
    }

    const _flashback = get().flashback;

    if (!_flashback) return;

    set({ flashback: { ..._flashback, [propertyToUpdate]: flashback[propertyToUpdate] } });
  }
}));

export default useFlashbackStore;
